/* tslint:disable */
/* eslint-disable */
export enum AdvisorRole {
  PrimaryAdvisor = 'PRIMARY_ADVISOR',
  Supervisor = 'SUPERVISOR'
}
